import { useMemo } from 'react';

import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';
import { useSourceByEnvironment } from '@/hooks/discovery/source';
import { ParsedUniqueId } from '@/typings/parseUniqueId';
import { useEnvironmentScope } from '../useEnvironmentScope';

export const useSource = (
  uniqueId: ParsedUniqueId | undefined,
  environmentId?: number,
) => {
  const { userId } = useEnvironmentScope();
  const { environmentId: inheritedEnvironmentId } = useDbtCloudProject();
  const validEnvironmentId = environmentId ?? inheritedEnvironmentId;

  const [{ fetching, error, data }] = useSourceByEnvironment({
    environmentId: validEnvironmentId,
    userId,
    uniqueId: uniqueId?.raw ?? '',
    pause: uniqueId?.resourceType !== 'source',
  });

  const sourceQuery = useMemo(() => {
    const appliedEdge = data?.environment.applied?.sources.edges?.[0];
    return {
      fetching,
      error,
      data: {
        applied: appliedEdge?.node,
        adapterType: data?.environment.adapterType,
        latestGitSha: data?.environment.applied?.latestGitSha,
      },
    };
  }, [fetching, error, data]);

  return sourceQuery;
};
